import { createAction, props } from '@ngrx/store';
import { TimeTrackingListTabsEnum } from '../../enums';
import { TimeTrackingListItemState } from '../reducers';

export const LoadRecordsList = createAction(
  '[Time tracking] Load Records List',
  props<{ recordsListData: TimeTrackingListItemState, status: TimeTrackingListTabsEnum, page: number }>()
);
